/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GdmApprovalRequest = {
  properties: {
    userId: {
      type: 'string',
      isRequired: true,
    },
    professionalId: {
      type: 'string',
      isRequired: true,
    },
    reason: {
      type: 'string',
      isRequired: true,
    },
    document: {
      type: 'File',
    },
  },
} as const;
